import AbsComponent from "./AbsComponent";
import Pagination from "./Pagination";

export default class SearchList extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='',_l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);


        this.page = new Pagination('.result-list-wrap > .ui-pagination ul', 8, this.pageCallback.bind(this));

        this.paramsStack = [];
        
        const watchQ = this.watch(this.store.getState, 'query', this.isEqual);
        this.store.subscribe( watchQ( this.stack.bind(this) ) );

        const watchJ = this.watch(this.store.getState, 'job', this.isEqual);
        this.store.subscribe( watchJ( this.stack.bind(this) ) );

        const watchP = this.watch(this.store.getState, 'page', this.isEqual);
        this.store.subscribe( watchP( this.stack.bind(this) ) );

        const watchParams = this.watch(this.store.getState, 'isParamsLoaded', this.isEqual);
        this.store.subscribe( watchParams( this.loadList.bind(this) ) );
    }

    stack(_newVal, _oldVal, _path){
        this.paramsStack.push( _path );
    }
    
    loadList(_newVal, _oldVal, _path){
        if (!_newVal || this.paramsStack.length<1) return;

        let params = {
            c: this.store.getState().query,
            p: this.store.getState().page,
            size: 8
        };

        if (this.store.getState().job) {
            params['job'] = this.store.getState().job;
        }

        // this.loading.addClass('is-show');
        axios( {
            method: 'GET',
            url: `${this.store.getState().config.apiDomain}/ingame/api/character/search/v2/list.json`,
            params: params
        })
        .then( (_res) => {
            this.render(_res.data);
            this.page.render({
                page: parseInt(this.store.getState().page),
                total: _res.data.total_count
            });
        })
        .catch( (error) => {
            console.log( 'error---', error.response );
            this.page.render({
                page: 1,
                total: 0
            });
        })
        .then( (d) => {
            // this.loading.removeClass('is-show');
        } );
        this.paramsStack = [];
    }

    render(_newVal, _oldVal, _path){

        let lang = $('html').attr('lang') || 'ko';

        let template = _newVal.list.map( it =>{
            const item = $(`
                <div class="character-list-items" onclick="return false;">
                    <div class="profileimg">
                        ${(lang==='ko')?`
                        <img src="${this.store.getState().config.profileImgPath}/game_profile_images/bns/images?gameServerKey=${it.server_id}&charKey=${it.character_id}">
                        `:`
                        <img src="${this.store.getState().config.staticPath}/img/profile/${it.job_eng_code}.png">
                        `}
                    </div>
                    <div class="result-items-info">
                        <div class="name">${it.name}</strong></div>
                        <span class="server">${it.server_name}</span>
                        <span class="races">${it.class_name}</span>
                        <span class="level">Lv. ${it.level}${it.mastery_level>0?` · ${this.l10n.masteryLevel.replace('{n}', it.mastery_level)}`:``}</span>
                    </div>
                </div>
            `);

            item.on('click', e=>{
                this.router.goMultiParam({ c: it.name, compare: 'false' });
            })

            return item;
        } );

        $(this.el + ' .messagebox-first').hide();
        $(this.el + ' .messagebox-noresult').toggle(_newVal.total_count<1);

        $(this.el + '> .character-list').empty().append(template);
        // $('.result-list-wrap .count').html(`${_newVal.total_length}`);    <strong class="count">----</strong>
        $('.result-list-wrap .result-count').html(  this.l10n.searchResultLeng.replace('{n}', `<strong class="count">${_newVal.total_count}</strong>`)  );
    }

    pageCallback(_d){
        this.router.goMultiParam({page: _d});
    }

} // end of class